import { render, staticRenderFns } from "./PurExD.vue?vue&type=template&id=1619e4da"
import script from "./PurExD.vue?vue&type=script&lang=js"
export * from "./PurExD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports